function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedNoBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 27.335L27.335 3l1.326 1.325L4.325 28.661 3 27.335z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.999 15.777c1.207.914 2 2.349 2 3.976V29h-2v-3H9.814l2-2H27v-4.247c0-1.654-1.346-3-3-3h-4.938l2-2h.848a7.218 7.218 0 00-.148-.7l1.582-1.582c.294.73.494 1.523.59 2.282H24c.343 0 .677.035 1 .101v-4.039l2-2v6.962zM21.999 3c.735 0 1.433.16 2.062.446l-1.59 1.59A3.016 3.016 0 0021.999 5h-12c-1.654 0-3 1.346-3 3v6.854a4.923 4.923 0 011-.101h.066c.31-2.424 1.681-5.19 3.753-5.19h6.126l-2 2h-4.126c-.56 0-1.455 1.466-1.728 3.19h2.665l-2 2H7.999c-1.654 0-3 1.346-3 3v2.756l-2 2v-4.756c0-1.627.793-3.062 2-3.976V8c0-2.757 2.243-5 5-5h12z",
    fill: props.color
  }));
}

export default SvgIconBedNoBedFilled;